import { IWorkInstructionExampleDTO } from "../common/types";
import { WorkInstructionExampleEntity } from "../../../core/domain/entities/checklist/WorkInstructionExampleEntity";

export class WorkInstructionExampleMapper {
  public static fromDTO(DTO: IWorkInstructionExampleDTO) {
    return WorkInstructionExampleEntity.existing(DTO.uid, DTO.uri);
  }
}
